import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

function ProjectCards(props) {
  const [showMessage, setShowMessage] = useState(false);

  const handleOrganizationalClick = (e) => {
    e.preventDefault();
    setShowMessage(true);
    setTimeout(() => setShowMessage(false), 3000);
  };

  const organizationalTooltip = (
    <Tooltip id="organizational-tooltip">
      This is an organizational/company project - details cannot be shared publicly
    </Tooltip>
  );

  // Cards added from the admin page: "enterprise" hides only the GitHub link,
  // a real demo link still opens, and empty links render no button.
  const dynamic = props.orgGithubOnly;

  const renderButton = (href, icon, text, isOrganizational) => {
    if (isOrganizational) {
      return (
        <OverlayTrigger
          placement="top"
          overlay={organizationalTooltip}
          delay={{ show: 250, hide: 400 }}
        >
          <Button 
            variant="primary" 
            onClick={handleOrganizationalClick}
            style={{ cursor: 'pointer' }}
          >
            {icon} &nbsp; {text}
          </Button>
        </OverlayTrigger>
      );
    } else {
      return (
        <Button variant="primary" href={href} target="_blank">
          {icon} &nbsp; {text}
        </Button>
      );
    }
  };

  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        
        {(!dynamic || props.isOrganizational || props.ghLink) &&
          renderButton(
            props.ghLink,
            <BsGithub />,
            props.isBlog ? "Blog" : "GitHub",
            props.isOrganizational
          )}

        {"\n"}
        {"\n"}

        {/* If the component contains Demo link and if it's not a Blog then, it will render the below component  */}
        {!props.isBlog && props.demoLink && (
          renderButton(
            props.demoLink, 
            <CgWebsite />, 
            "Demo",
            props.isOrganizational && !dynamic
          )
        )}

        {/* Message display for organizational projects */}
        {showMessage && (
          <div 
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: '#333',
              color: 'white',
              padding: '20px',
              borderRadius: '8px',
              zIndex: 1000,
              boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
              textAlign: 'center',
              maxWidth: '300px'
            }}
          >
            <p style={{ margin: 0, fontSize: '14px' }}>
              This is an organizational/company project. 
              <br />
              Details cannot be shared publicly due to confidentiality.
            </p>
          </div>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
